module.exports = __webpack_public_path__ + "media/packs/images/flags/CI-ad0ef29072dbb0ff9f657f7b681fdf56.svg";